export default {
    data() {
        return {
            statesOptions: [],
            statesLoaded: false,
            isManualState: false
        };
    },
    methods: {
        /**
         * Load country states
         * @param {String} country Country ISO code
         */
        async loadStatesOptions(country) {
            this.statesLoaded = false;
            try {
                const res = await this.$usersService.getCountryStates(country);
                const { provinces } = res.data;
                const provincesWithLiterals = provinces.map(x => {
                    return { name: x.name, key: x.key_name };
                });
                provincesWithLiterals.sort(this.compare);
                this.statesOptions = provincesWithLiterals;
                this.statesLoaded = true;
            } catch (error) {
                this.isManualState = true;
                this.statesLoaded = true;
                console.error(error);
            }
        },
        compare(a, b) {
            return a.name.localeCompare(b.name);
        }
    },

    /**
     * Se setea a false el flag que indica si están cargadas las regiones
     */
    beforeMount() {
        this.statesLoaded = false;
    }
};
